// src/Pages/Landing/JoyridePaijatHameLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";

export default function JoyridePaijatHameLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Päijät-Häme"
      cities={[
        "Lahti",
        "Hollola",
        "Orimattila",
        "Heinola",
        "Asikkala",
        "Iitti",
        "Padasjoki"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Päijät-Hämeen alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Lahden seutu ja lähikunnat sopivat hyvin esimerkiksi häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin, kun juhliin halutaan energinen livebändi."
      bookingLink="/#varaa"
    />
  );
}